import { render, staticRenderFns } from "./NestedDatasetDisplay.vue?vue&type=template&id=2514a3b0&scoped=true"
import script from "./NestedDatasetDisplay.vue?vue&type=script&lang=js"
export * from "./NestedDatasetDisplay.vue?vue&type=script&lang=js"
import style0 from "./NestedDatasetDisplay.vue?vue&type=style&index=0&id=2514a3b0&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/.pnpm/vue-loader@15.11.1_css-loader@2.1.1_webpack@4.47.0__lodash@4.17.21_prettier@2.8.8_vue-t_9526555e5c4a4a2f93e9ca761d6e387d/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2514a3b0",
  null
  
)

export default component.exports